// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"936d2518","453":"d31efba0","455":"09b5507b","977":"f39c52f2"}[chunkId] + ".chunk.js";
};